export const CITY_OPTIONS = [
    { label: "Amsterdam", value: "Amsterdam" },
    { label: "Rotterdam", value: "Rotterdam" },
    { label: "Eindhoven", value: "Eindhoven" },
    { label: "Utrecht", value: "Utrecht" }
];

export const DESCRIPTION_LENGTH = 350;

export const EXTERNAL_LINKS = {
    CINEVILLE: "https://www.cineville.nl",
    BUY_ME_COFFEE: "https://www.buymeacoffee.com/manfredi",
    TMDB_BASE: "https://www.themoviedb.org/movie/",
    MEDIA_BASE: "https://eventspire.nl/media/"
};